var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.94656 0 0 8.94508 0 20C0 31.0534 8.94508 40 20 40C31.0534 40 40 31.0549 40 20C40 8.94656 31.0549 0 20 0ZM21.5625 36.8031V35.3646C21.5625 34.5016 20.863 33.8021 20 33.8021C19.137 33.8021 18.4375 34.5016 18.4375 35.3646V36.8031C10.3624 36.0665 3.93344 29.6364 3.19695 21.5625H4.63547C5.49844 21.5625 6.19797 20.863 6.19797 20C6.19797 19.137 5.49844 18.4375 4.63547 18.4375H3.19695C3.93352 10.3624 10.3636 3.93344 18.4375 3.19687V4.63539C18.4375 5.49836 19.137 6.19789 20 6.19789C20.863 6.19789 21.5625 5.49836 21.5625 4.63539V3.19687C29.6376 3.93352 36.0666 10.3636 36.803 18.4375H35.3645C34.5016 18.4375 33.802 19.137 33.802 20C33.802 20.863 34.5016 21.5625 35.3645 21.5625H36.803C36.0665 29.6376 29.6364 36.0666 21.5625 36.8031ZM27.2507 25.0409C27.8609 25.6512 27.8609 26.6405 27.2507 27.2506C26.6405 27.8609 25.6512 27.8608 25.041 27.2506L18.8952 21.1048C18.6021 20.8119 18.4375 20.4144 18.4375 20V10.7812C18.4375 9.91828 19.137 9.21875 20 9.21875C20.863 9.21875 21.5625 9.91828 21.5625 10.7812V19.3528L27.2507 25.0409Z",
    fill: "#4322C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f6abecb6b6894e77cc36d4a12ef93d0f.svg";
export { ForwardRef as ReactComponent };